export default __webpack_public_path__ + "static/media/malay-logo-dark.729af550.svg";